import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDesuperHeater = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 50,
	viewBox: "0 0 50.0 50.0",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		x: 0,
		y: 0,
		width: 50,
		height: 50,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgDesuperHeater;
